export enum EventIcon {
    calendar = 'calendar',
    singing = 'singing',
    music = 'music',
    dancing = 'dancing',
    hiking = 'hiking',
    outdoors = 'outdoors',
    park = 'park',
    gardening = 'gardening',
    dinner = 'dinner',
    coffee = 'coffee',
    drinks = 'drinks',
    baking = 'baking',
    games = 'games',
    reading = 'reading',
    film = 'film',
    arts = 'arts',
    crafts = 'crafts',
    exercise = 'exercise',
    sports = 'sports',
    swimming = 'swimming',
    trip = 'trip',
    celebration = 'celebration',
    social = 'social',
    wellbeing = 'wellbeing',
    animals = 'animals',
}

export type EventIconOption = {
    key: EventIcon;
};

export const EVENT_ICON_OPTIONS: EventIconOption[] = Object.values(
    EventIcon,
).map(key => ({ key }));

const EVENT_ICONS_BY_KEY = new Set(EVENT_ICON_OPTIONS.map(({ key }) => key));

export const getEventIcon = (
    icon?: EventIcon | null,
): EventIconOption | undefined =>
    icon && EVENT_ICONS_BY_KEY.has(icon) ? { key: icon } : undefined;
